<div data-cy="import-file-modal__page" mat-dialog-title>
    <span class="generic-color d-cursor-hand">
        <h4 class="ml-10 mb-10 inline-block ts-20">{{ modalTitle }}</h4>
    </span>
    <button data-cy="import-file-modal__close-btn" type="button" class="close modal-close-button" (click)="close()" >
        <span aria-hidden="true">
            <i class="d-text-middle uil uil-multiply unicon-icon"></i>
        </span>
        <span class="sr-only">{{ 'reusable.close' | transloco }}</span></button>
</div>

<mat-dialog-content data-cy="import-file-modal__dialog-content">
  <ng-container *ngIf="showErrorsTable">
    <ng-container *ngFor="let section of chunkSections">
      <h5 class="mt-20 mb-10 ml-10">{{ getChunkLabelKey(section.key) | capitaliz }}</h5>
      <table data-cy="import-file-modal__table" mat-table [dataSource]="section.failedItems" class="error-table mt-10 mb-20">
        <ng-container matColumnDef="row">
          <th mat-header-cell *matHeaderCellDef>
            <span class="font-normal">{{ 'imports.row_number' | transloco }}</span>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.rows ?? '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="error_message">
          <th mat-header-cell *matHeaderCellDef>
            <span class="font-normal">{{ 'imports.error' | transloco }}</span>
          </th>
          <td mat-cell *matCellDef="let element">{{ getDisplayErrorMessage(element.error_message) }}</td>
        </ng-container>   
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            <span class="font-normal">{{ 'imports.status' | transloco }}</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="status failed flex align-center gap-6">
              <img *ngIf="element?.status?.toLowerCase() === 'failed'" [style.width.px]="20" [style.height.px]="20" src="assets/icons/failed.svg" alt="failed">
              {{ 'imports.status_failed' | transloco | capitaliz }}
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="errorDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: errorDisplayedColumns"></tr>
      </table>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="showStatusSummary">
    <table data-cy="import-file-modal__table-2" mat-table [dataSource]="statusSummaryItems" class="mat-elevation-z1 full-width">
      <ng-container matColumnDef="item">
        <th mat-header-cell *matHeaderCellDef>{{ 'imports.sheet' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{ element.item | capitaliz }}</td>
      </ng-container>

      <ng-container matColumnDef="rows">
        <th mat-header-cell *matHeaderCellDef>{{ 'imports.rows' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{ element.rows }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{ 'imports.status' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
          <span class="status" [ngClass]="element.status.toLowerCase()">
            <img *ngIf="element.status === 'success'" width="17" height="17" src="assets/icons/success.svg" />
            <img *ngIf="element.status === 'failed'" width="20" height="20" src="assets/icons/failed.svg" />
            {{ element.status | titlecase }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="statusDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: statusDisplayedColumns"></tr>
    </table>
    <p class="mt-20 ml-10" *ngIf="showGeoJsonErrorDetail" data-cy="import-file-modal__geojson-error">
      {{ getDisplayErrorMessage(statusSummaryItems[0]?.error) }}
    </p>
  </ng-container>
  
  <div *ngIf="showNoDataMessage" class="no-data-container">
    <i class="uil uil-file fs-40 mb-2 generic-color"></i>
    <p class="mt-2">{{ 'imports.no_data_available' | transloco }}</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions data-cy="import-file-modal__dialog-actions" align="end" class="mt-35 pb-35">
    <mat-dialog-actions data-cy="import-file-modal__dialog-actions-2" align="end" class="mt-20">
        <button data-cy="import-file-modal__close-btn-2" mat-flat-button (click)="close()">{{ 'close' | transloco }}</button>
    </mat-dialog-actions>
</mat-dialog-actions>